import { render, staticRenderFns } from "./articleCategory.vue?vue&type=template&id=82ca3c1c&scoped=true&"
import script from "./articleCategory.vue?vue&type=script&lang=js&"
export * from "./articleCategory.vue?vue&type=script&lang=js&"
import style0 from "./articleCategory.vue?vue&type=style&index=0&id=82ca3c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ca3c1c",
  null
  
)

export default component.exports